var React = require('react');

function Logo1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M111.323 0.261309H103.404L135.081 29.946H143L111.323 0.261309ZM120.655 21.3228L111.525 29.946H103.656L112.786 21.3228H120.655ZM133.87 8.83223L143 0.209047H135.131L126.001 8.83223H133.87ZM19.9746 0L16.6959 4.86034L33.3414 29.946H39.9492L19.9746 0ZM11.551 12.6996H18.1083L6.60776 29.946H0L11.551 12.6996ZM79.394 0L76.1153 4.86034L92.7608 29.946H99.3686L79.394 0ZM70.9199 12.6996H77.4773L65.9767 29.946H59.369L70.9199 12.6996ZM52.7612 0.261309V18.4484C52.7612 21.4273 51.4497 25.0856 46.9605 25.3992H45.3464V29.9982C45.3464 29.9982 46.7587 29.9982 47.7171 29.9982C49.8861 30.0505 52.963 28.953 54.9302 26.8103C57.6035 23.8313 57.9566 20.0162 57.9566 18.1871V0.261309H52.7612Z","fill":"white"}));
}

Logo1.defaultProps = {"width":"143","height":"30","viewBox":"0 0 143 30","fill":"none"};

module.exports = Logo1;

Logo1.default = Logo1;
